import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Container, InnerContainer } from './styles';
export var ImagesLoadingSkeleton = function () { return (React.createElement(Container, null,
    React.createElement("div", { style: { width: '50%' } },
        React.createElement(Skeleton, { width: "100%", height: "100%" })),
    React.createElement(InnerContainer, null, Array.from(Array(4).keys()).map(function (e, index) { return (React.createElement(Skeleton, { width: "100%", height: "100%", key: "images-skeleton-" + index })); })))); };
